import * as React from "react";
import { Box, Container } from "@mui/material";
import { marketingPageShellSx } from "../tickitMarketingTheme";

/** Public page shell — matches platform HTML `.content` area */
export default function MarketingPage({ children, maxWidth = "lg", sx = {}, id = "main-content" }) {
  return (
    <Box
      component="main"
      id={id}
      sx={{
        ...marketingPageShellSx,
        pt: { xs: 2.5, md: 3.25 },
        pb: { xs: 4, md: 5 },
        px: { xs: 2, md: 0 },
        ...sx,
      }}
    >
      <Container maxWidth={maxWidth} sx={{ px: { xs: 0, sm: 2, md: 3 } }}>
        {children}
      </Container>
    </Box>
  );
}
